import { render, staticRenderFns } from "./ListGroupBadge.vue?vue&type=template&id=0bf3c4de&"
import script from "./ListGroupBadge.vue?vue&type=script&lang=js&"
export * from "./ListGroupBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports